<div class="leads-history-info">
  <!-- Histórico de Contato -->
  <div class="history-section">
    <h2 class="section-title">Histórico de contato</h2>
    <div class="divider"></div>

    <!-- Loading State para Contatos -->
    <div *ngIf="contactLoading" class="loading-state">
      <div class="loading-spinner"></div>
      Carregando histórico de contatos...
    </div>

    <!-- Error State para Contatos -->
    <div *ngIf="contactError && !contactLoading" class="error-state">
      <div class="error-icon">⚠️</div>
      <p>{{ getContactErrorMessage() }}</p>
    </div>

    <!-- Success State -->
    <app-nf-table
      *ngIf="!contactLoading && !contactError && contactHistoryData.length > 0"
      [columns]="contactHistoryColumns"
      [data]="contactHistoryData"
      [showPagination]="true">
    </app-nf-table>

    <!-- Empty State -->
    <p *ngIf="!contactLoading && !contactError && contactHistoryData.length === 0" class="no-records">
      Nenhum contato registrado para esta lead.
    </p>
  </div>

  <!-- Histórico de Relacionamento -->
  <div class="history-section">
    <h2 class="section-title">Histórico de relacionamento</h2>
    <div class="divider"></div>
    <app-nf-table
      *ngIf="relationshipHistoryData.length > 0"
      [columns]="relationshipHistoryColumns"
      [data]="relationshipHistoryData">
    </app-nf-table>
  </div>

  <!-- Histórico de Financiamento -->
  <div class="history-section">
    <h3 class="subsection-title">Histórico de Financiamento</h3>
    <div class="divider"></div>
    <app-nf-table
      *ngIf="financingHistoryData.length > 0"
      [columns]="financingHistoryColumns"
      [data]="financingHistoryData">
    </app-nf-table>
    <p *ngIf="financingHistoryData.length === 0" class="no-records">Nenhum registro anterior</p>
  </div>

  <!-- Histórico de Simulação -->
  <div class="history-section">
    <h3 class="subsection-title">Histórico de Simulação</h3>
    <div class="divider"></div>

    <!-- Loading State para Simulação -->
    <div *ngIf="simulationLoading" class="loading-state">
      <div class="loading-spinner"></div>
      Carregando histórico de simulação...
    </div>

    <!-- Error State para Simulação -->
    <div *ngIf="simulationError && !simulationLoading" class="error-state">
      <div class="error-icon">⚠️</div>
      <p>{{ getSimulationErrorMessage() }}</p>
    </div>

    <app-nf-table
      *ngIf="!simulationLoading && !simulationError && simulationHistoryData.length > 0"
      [columns]="simulationHistoryColumns"
      [data]="simulationHistoryData"
      [showPagination]="true">
    </app-nf-table>

    <p *ngIf="!simulationLoading && !simulationError && simulationHistoryData.length === 0" class="no-records">
      Nenhum registro anterior
    </p>
  </div>

  <!-- Histórico de Consórcio -->
  <div class="history-section">
    <h3 class="subsection-title">Histórico de consórcio</h3>
    <div class="divider"></div>
    <app-nf-table
      *ngIf="consortiumHistoryData.length > 0"
      [columns]="consortiumHistoryColumns"
      [data]="consortiumHistoryData">
    </app-nf-table>
    <p *ngIf="consortiumHistoryData.length === 0" class="no-records">Nenhum registro anterior</p>
  </div>

  <!-- Histórico de Assinatura -->
  <div class="history-section">
    <h3 class="subsection-title">Histórico de assinatura</h3>
    <div class="divider"></div>
    <app-nf-table
      *ngIf="signatureHistoryData.length > 0"
      [columns]="signatureHistoryColumns"
      [data]="signatureHistoryData">
    </app-nf-table>
    <p *ngIf="signatureHistoryData.length === 0" class="no-records">Nenhum registro anterior</p>
  </div>
</div>

<!-- BOTÕES NOVOS - APENAS ESTA DIV É NOVA -->
<div class="right-nav-buttons">
  <button class="nav-btn" (click)="navigateToPage(0)">Informações Gerais</button>
  <button class="nav-btn" (click)="navigateToPage(1)">Detalhes da Oferta</button>
</div>
